import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VExpansionPanel,{attrs:{"expand":_vm.expand}},_vm._l((_vm.faqList),function(faq){return _c('FaqAccordion',{key:faq.question,attrs:{"question":faq.question,"answer":faq.answer}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }